export default __webpack_public_path__ + "static/media/organisation.f0f35b63.jpg";